import { aggregateMetrics, productReady } from '@petrotrack/shared'
import { filterEntriesByDate, todayStr } from '../../utils/dateFilters'
import { getBranchProducts } from '../../utils/dataHelpers'
import { formatNaira } from '../../utils/formatters'
import ProductCard from './ProductCard'

export default function BranchCard({ branch, organization, entries, expenses, filters, currentUser, onEnterData, onEditEntry, onDeleteEntry }) {
  const products = getBranchProducts(branch, filters)
  const branchEntries = filterEntriesByDate(entries.filter((e) => e.branchId === branch.id), filters.dateFilter, filters.customRange)
  const branchExpenses = filterEntriesByDate(expenses.filter((x) => x.branchId === branch.id), filters.dateFilter, filters.customRange)
  const s = aggregateMetrics(branchEntries, branchExpenses)

  const today = todayStr()
  const isAdmin = currentUser.role === 'admin' || currentUser.role === 'superadmin'
  const canEnter = currentUser.role === 'manager' && branch.id === currentUser.branchId
  const canEditEntry = (e) => currentUser.role === 'superadmin' || (currentUser.role === 'manager' && e?.date === today)

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
      <div>
        <h3 className="font-bold text-gray-800">{branch.name}</h3>
        {organization && <p className="text-xs text-gray-400">{organization.name}</p>}
      </div>

      {products.length === 0 ? (
        <div className="text-sm text-gray-400 py-6 text-center bg-gray-50 rounded-xl">
          <p>No tanks/pumps set up</p>
          <p className="text-xs mt-1">
            {isAdmin ? 'Add them in Profile → Branches → Edit to start recording entries.' : 'Ask your admin to add them before entries can be recorded.'}
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {products.map((product) => {
            const productEntries = branchEntries.filter((e) => e.product === product)
            const latest = productEntries[0] || null
            const r = productReady(branch, product)
            return (
              <ProductCard key={product} product={product} entries={productEntries} latest={latest}
                isAdmin={isAdmin} canEnter={canEnter} canEdit={canEditEntry(latest)}
                setupMissing={r.ready ? [] : r.missing}
                onEnter={(p) => onEnterData(branch, p)} onEdit={(entry) => onEditEntry(branch, entry)} onDelete={onDeleteEntry} />
            )
          })}

          <div className="bg-gray-50 rounded-xl p-3">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Station total</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-1 gap-x-4">
              <Sum label="Revenue" value={formatNaira(s.revenue)} />
              <Sum label="Excess Profit" value={formatNaira(s.measuredExcessProfit)} />
              <Sum label="Expenses" value={formatNaira(s.totalExpenses)} cls="text-red-500" />
              <Sum label="Net Profit" value={formatNaira(s.netProfit)} cls="text-purple-600" />
              <Sum label="To Remit" value={formatNaira(s.amountToRemit)} cls="text-green-700 font-bold" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

function Sum({ label, value, cls = 'text-gray-800' }) {
  return <div className="flex justify-between"><span className="text-xs text-gray-400">{label}</span><span className={`text-xs font-semibold ${cls}`}>{value}</span></div>
}
